module.exports = __webpack_public_path__ + "img/business5.c7f5eb63.png";